/**
 * Copyright (C) Techniserv, spol. s r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export default function ({value, labelText, isChecked, namespace}) {
  const radioButton = document.createElement('div')
  radioButton.classList.add('gov-form-control', 'gov-form-control--custom')

  const radioButtonInput = document.createElement('input')
  radioButtonInput.id = `${namespace}radio_button_input${value}`
  radioButtonInput.classList.add('gov-form-control__radio')
  radioButtonInput.type = 'radio'
  radioButtonInput.ariaRequired = false
  radioButtonInput.value = value
  radioButtonInput.name = 'feedback_reason'
  radioButtonInput.checked = isChecked

  const radioButtonLabel = document.createElement('label')
  radioButtonLabel.classList.add('gov-form-control__label')
  radioButtonLabel.innerText = labelText
  radioButtonLabel.htmlFor = `${namespace}radio_button_input${value}`

  const radioButtonIcon = document.createElement('span')
  radioButtonIcon.classList.add('gov-form-control__indicator', 'feedback_radio_button_icon')

  const radioButtonValidationMark = document.createElement('span')
  radioButtonValidationMark.classList.add('gov-form-control__validation-mark')
  radioButtonValidationMark.tabIndex = -1

  radioButton.append(radioButtonInput, radioButtonLabel, radioButtonIcon, radioButtonValidationMark)
  return radioButton
}